export default __webpack_public_path__ + "static/media/EnterIcon.80bdd45b.svg";